import React from 'react';
import './CheckoutViewSkeleton.css';

const Bone = ({ w, h = 10, r = 6, className = '' }) => (
  <span className={`cv-sk-bone ${className}`} style={{ width: w, height: h, borderRadius: r }} />
);

const AREAS = [4, 3];

/** Skeleton de carregamento do Fechamento (sidebar de áreas + técnicos + detalhe). */
export default function CheckoutViewSkeleton() {
  return (
    <>
      <div className="checkout-view-sidebar cv-sk" role="status" aria-live="polite" aria-label="Carregando fechamento">
        <Bone w="100%" h={44} r={10} className="cv-sk-select-all" />
        {[1, 2, 3, 4].map((i) => (
          <Bone key={i} w={48} h={48} r={12} className="cv-sk-avatar" />
        ))}
      </div>

      <div className="checkout-view-main cv-sk">
        <div className="checkout-view-technician-list-header">
          <Bone w={68} h={12} />
          <div className="cv-sk-row">
            <Bone w={24} h={24} r={7} />
            <Bone w={24} h={24} r={7} />
          </div>
        </div>
        <div className="checkout-view-technician-list">
          {AREAS.map((techs, block) => (
            <div key={block} className="checkout-view-area-block">
              <div className="cv-sk-row cv-sk-area-title">
                <Bone w={block === 0 ? '52%' : '40%'} h={11} />
                <Bone w={14} h={14} r={4} className="cv-sk-push" />
              </div>
              {Array.from({ length: techs }).map((_, i) => (
                <div key={i} className="cv-sk-row cv-sk-tech">
                  <Bone w={22} h={22} r={999} />
                  <Bone w={`${48 + ((i * 17) % 30)}%`} h={10} />
                  <Bone w={26} h={16} r={999} className="cv-sk-push" />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>

      <div className="checkout-view-detail cv-sk">
        <div className="checkout-view-detail-main">
          <div className="cv-sk-detail">
            {[1, 2, 3].map((i) => (
              <div key={i} className="cv-sk-card">
                <div className="cv-sk-row">
                  <Bone w={32} h={32} r={999} />
                  <div className="cv-sk-col">
                    <Bone w="58%" h={11} />
                    <Bone w="36%" h={8} />
                  </div>
                  <Bone w={78} h={18} r={999} />
                </div>
                <div className="cv-sk-row">
                  <Bone w={`${40 + ((i * 13) % 30)}%`} h={9} />
                  <Bone w={60} h={9} className="cv-sk-push" />
                </div>
                <div className="cv-sk-row">
                  <Bone w={64} h={18} r={999} />
                  <Bone w={52} h={18} r={999} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
